import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./duplicate_item_merge_mode.js";
//#region src/duplicate_item_merge_mode_helper.ts
var duplicate_item_merge_mode_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(mode) {
	switch (mode) {
		case "none": return "None";
		case "scanned": return "Scanned Items";
		case "scanned-and-simple": return "Scanned and Simple Items";
	}
}
//#endregion
export { duplicate_item_merge_mode_helper_exports, name };

//# sourceMappingURL=duplicate_item_merge_mode_helper.js.map